import React, { useState, useEffect } from 'react';
import { Type, Mail, Phone, MapPin } from 'lucide-react';

export function AccessibilityBar() {
  const [fontSizeIndex, setFontSizeIndex] = useState(0); // 0: normal, 1: large, 2: extra large

  useEffect(() => {
    // Apply font size
    const scales = ['100%', '112%', '125%'];
    document.documentElement.style.fontSize = scales[fontSizeIndex];
  }, [fontSizeIndex]);

  return (
    <aside 
      className="bg-[#0b1c30] text-[#c5d7f2] border-b border-[#233e66] py-2 px-4 text-xs font-sans relative z-[60]"
      role="region"
      aria-label="Quick Information and Display Settings Bar"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center gap-2.5 sm:gap-3">
        {/* Direct Contact Info & Geo Metadata */}
        <div className="flex flex-wrap items-center gap-2.5 sm:gap-4 text-[11px] font-medium min-w-0">
          <a 
            href="mailto:care@swaroopwebsolutions.com" 
            className="flex items-center gap-1.5 hover:text-white transition-colors focus:ring-2 focus:ring-white rounded px-1 min-w-0 truncate"
            aria-label="Send email to care@swaroopwebsolutions.com"
          >
            <Mail size={13} className="text-[#38bdf8] shrink-0" />
            <span className="truncate">care@swaroopwebsolutions.com</span>
          </a>
          <a 
            href="tel:+919175931452" 
            className="flex items-center gap-1.5 hover:text-white transition-colors focus:ring-2 focus:ring-white rounded px-1 shrink-0"
            aria-label="Call +91 91759 31452"
          >
            <Phone size={13} className="text-[#4ade80] shrink-0" />
            <span>+91 91759 31452</span>
          </a>
          <span className="hidden md:flex items-center gap-1 text-white font-medium shrink-0">
            <MapPin size={12} className="text-[#38bdf8] shrink-0" />
            <span className="text-white">Pune, Maharashtra (Serving Global)</span>
          </span>
        </div>

        {/* Text Size Shortcut */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => setFontSizeIndex((prev) => (prev + 1) % 3)}
            className="px-2.5 py-1 rounded text-[11px] font-bold bg-[#132742] text-white border border-[#2a4365] hover:bg-[#1e3a5f] flex items-center gap-1 transition-colors cursor-pointer shrink-0"
            aria-label="Cycle Text Size for Readability"
          >
            <Type size={12} />
            <span>Text: {fontSizeIndex === 0 ? 'Normal' : fontSizeIndex === 1 ? 'Large' : 'XL'}</span>
          </button>
        </div>
      </div>
    </aside>
  );
}
